import { useOrganization } from './api/queries/organization'

export const useOrganizationType = () => {
   const organizationId = useOrganizationId()
   const organization = useOrganization(
      computed(() => ({
         id: organizationId.value,
         enabled: !!organizationId.value,
      }))
   )

   const organizationType = computed(() => organization.data.value?.[0]?.type)

   return organizationType
}
